<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3z2YIn/tc-custom/9781399069120.jpg?1733033961659" alt="This image is the cover for the book First Enigma Codebreaker"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">First Enigma Codebreaker
      </h1>
      <p class="bookDescription body article font2">
        <p>The First Enigma Codebreaker is the story of a man who started a revolution in cryptology and the conflict between man and machine. This is a powerful story of the life of Marian Rejewski and how history can affect individual lives, presented to the public for the first time.  This examination of how Marian Rejewski changed the course of cryptology is of great interest to everyone from the avid historian to Hollywood film producers and all those in-between. As Gawlowski’s biography shows, Rejewski was an unassuming man who used his mathematical, skills as well as his extensive linguistic abilities, to start cracking the Enigma code before passing the baton on to the now renowned Alan Turing. This is a fascinating, human story about the man Marian Rejewski, which also ties up the loose threads of the Enigma story and shows the importance of the Polish involvement in that process.  The First Enigma Codebreaker looks at those involved in cracking the Enigma and also takes a look at an aspect that has rarely been discussed in great detail, the story of Marian Rejewski himself, and how he endured life in post-war Communist Poland shining a light on situations such as how Rejewski managed to decode the machine, what happened to him during the Second World War, and the price he had to pay during the post war period.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Gawlowski
      </h2>
      
      <p class="authorDescription body article">ROBERT GAWLOWSKI was born in Bydgoszcz, the same city as Marian Rejewski. This is his first biography, but he has also published extensive scientific research in the field of social sciences, as well as many journalistic articles. He is a political analyst and academic working at a university, where he specialises in teaching subjects related to public administration and public management.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ace1cf6a